module.exports = __webpack_public_path__ + "static/img/施設掲載はこちら.6caec68.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/domain1/施設掲載はこちら.png
// module id = oPzS
// module chunks = 0